import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import EuropeanInput from "../../utils/European-Format/EuropeanInput";
import Header from "../../layouts/Header";
import CancelWarningModal from "../../components/Dailogs/CancelWarningModal";
import Xicon from "../../assets/icons/Xicon.svg";
import DownArrowOption from "../../assets/icons/DownArrowOption.svg";
import searchicon from "../../assets/icons/search.svg";
import DeleteIcon from "../../assets/icons/DeleteIcon.svg";
import blueAddButton from "../../assets/icons/blueAddButton.svg";
import greyAddButton from "../../assets/icons/greyAddButton.svg";
import "../../assets/styles/local/NewInvoice.css";
import "../../assets/styles/local/with_Search_img_SelectBox.css";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { toast } from "react-toastify";
import LogoSmall from "../../assets/images/logo-small.png";
import floatingSound from "../../assets/audios/floating-notification-tone.wav";
// import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd'
import { fetchScreenTranslations } from "../../utils/helpers/translations";

import {
  FetchClient,
  // ProjectDropdown,
  FetchProjectByClient,
  FetchQuotes,
  FetchProductByQuotes,
  Fetchproduct_Parts_List,
  AddInvoiceProject,
  FetchPaymentDeadline,
  FetchLastInvoiceCode,
  updateOrdersIndexPositions,
  FetchProjectById,
  AddCreditNote,
  FetchCreditInvoiceList,
  FetchLastCreditInvoiceCode,
  FetchInvoiceList,
  FetchInvoiceByInvoiceId,
} from "../../redux/actions/action";
import {
  ADD_INVOICE_PROJECT,
  ADD_CREDIT_NOTE,
} from "../../redux/constants/type";
import { useDispatch, useSelector } from "react-redux";

const CreditNote = () => {
  let today = new Date();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const locationState = location.state;
  const locationData = location.state;
  // const { supplierid, suppliername, projectname } = location.state;
  const Invoice_Popup_Ref = useRef(null);
  const Client_Popup_Ref = useRef(null);
  const hidden_Input_File = useRef(null);
  const Project_Popup_Ref = useRef(null);
  const quotes_Popup_Ref = useRef(null);
  const PaymentDeadline_Popup_Ref = useRef(null);
  const PaymentOptions_Popup_Ref = useRef(null);

  const companyId = window.localStorage.getItem("companyid");
  const userId = window.localStorage.getItem("userid");
  const roleAccess = window.localStorage.getItem("roleid");

  const fetchClient = useSelector((state) => state.user.fetchClient);

  const fetchProjectDropdown = useSelector(
    (state) => state.user.fetchProjectDropdown,
  );

  const fetchProductPartList = useSelector(
    (state) => state.user.fetchProductPartList,
  );

  const fetchQuotesResponse = useSelector(
    (state) => state.user.fetchQuotesResponse,
  );

  const addInvoiceProject = useSelector(
    (state) => state.user.addInvoiceProject,
  );

  const fetchPaymentDeadline = useSelector(
    (state) => state.user.fetchPaymentDeadline,
  );

  const fetchProjectByClientRes = useSelector(
    (state) => state.user.fetchProjectByClientRes,
  );

  const fetchProductsByQuotesRes = useSelector(
    (state) => state.user.fetchProductsByQuotesRes,
  );

  const fetchInvoiceAllListData = useSelector(
    (state) => state.user.fetchInvoioceAllList,
  );

  const fetchLastInvoiceCodeRes = useSelector(
    (state) => state.user.fetchLastInvoiceCodeRes,
  );

  const fetchProjectById = useSelector((state) => state.user.fetchProjectById);

  const addCreditNoteResponse = useSelector(
    (state) => state.user.addCreditNote,
  );

  const fetchLastCreditInvoiceCodeRes = useSelector(
    (state) => state.user.fetchLastCreditInvoiceCodeRes,
  );

  // VARIABLES START //

  // asc cancel popup start //
  const [cancelPopupShow, setCancelPopupShow] = useState(false);
  const handleClose = () => setCancelPopupShow(false);

  const handleCancel = (e) => {
    // history.push("/InvoiceAllList");
    history.goBack();
  };
  const [typeInScreen, setTypeInScreen] = useState("");
  // asc cancel popup end //

  const [apimessage, setApimessage] = useState("");
  const [relatedInvoiceData, setRelatedInvoiceData] = useState([]);
  const [typeAnItemWarn, setTypeAnItemWarn] = useState(false);
  const [searchInvoiceName, setSearchInvoiceName] = useState("");
  const [searchClientName, setSearchClientName] = useState("");
  const [invoiceName, setInvoiceName] = useState("");
  const [invoiceID, setInvoiceID] = useState("");
  const [clientName, setClientName] = useState("");
  const [clientAddress, setClientAddress] = useState("");
  const [clientCountry, setClientCountry] = useState("");
  const [clientData, setClientData] = useState([]);
  const [clientid, setClientid] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [invoiceShowOptions, setInvoiceShowOptions] = useState(false);
  const [clientShowOptions, setClientShowOptions] = useState(false);
  const [arrowOptionsRotate, setArrowOptionsRotate] = useState(false);
  const [arrowOptionsRotate2, setArrowOptionsRotate2] = useState(false);
  const [arrowOptionsRotate3, setArrowOptionsRotate3] = useState(false);
  const [arrowOptionsRotate4, setArrowOptionsRotate4] = useState(false);
  const [arrowOptionsRotate5, setArrowOptionsRotate5] = useState(false);
  const [arrowOptionsRotate6, setArrowOptionsRotate6] = useState(false);
  const [typeAnItemPopup, setTypeAnItemPopup] = useState(false);
  const [invoiceList, setInvoiceList] = useState([]);
  const [productPartList, setProductPartList] = useState([]);
  const [typeanItem, setTypeanItem] = useState("");
  const [projectsData, setProjectsData] = useState([]);
  const [projectShowOptions, setProjectShowOptions] = useState(false);
  const [quoteShowOptions, setQuoteShowOptions] = useState(false);
  const [paymentDeadlineOptions, setPaymentDeadlineOptions] = useState(false);
  const [paymentOthersOptions, setPaymentOthersOptions] = useState(false);
  const [dueDays, setDueDays] = useState("");
  const [description, setDescription] = useState("");
  const [paymentOptionShow, setPaymentOptionShow] = useState(false);
  const [chooseLinkShow, setChooseLinkShow] = useState(false);
  const [projectid, setProjectid] = useState("");
  const [searchProjectName, setSearchProjectName] = useState("");
  const [quotesData, setQuotesData] = useState([]);
  const [quotecode, setQuotecode] = useState("");
  const [quoteid, setQuoteid] = useState("");
  const [notes, setNotes] = useState("");
  const [poNumber, setPoNumber] = useState("");
  const [paymentDeadlineData, setPaymentDeadlineData] = useState([]);
  const [paymentDeadlineid, setPaymentDeadlineid] = useState("");
  const [paymentDeadline, setPaymentDeadline] = useState("");
  const [duedate, setDuedate] = useState("");
  const [invoiceStatus, setInvoiceStatus] = useState("");
  const [chooseOption, setChooseOption] = useState("");
  const [bankTransfer, setBankTransfer] = useState(true);
  const [quotesProductsData, setQuotesProductsData] = useState([]);
  const [lastCreditCode, setLastCreditCode] = useState("");

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [clientWarning, setClientWarning] = useState(false);
  const [showOrderNotification, setShowOrderNotification] = useState(false);
  const [clientFlag, setclientFlag] = useState(false); // state for client error warning
  const [projectFlag, setProjectFlag] = useState(false); // state for project error warning
  const [quoteFlag, setQuoteFlag] = useState(false); // state for quote error warning
  const projectId = window.localStorage.getItem("projectid");

  useEffect(() => {
    if (window.localStorage.getItem("asc_TypeAnItemPopup")) {
      setTypeAnItemPopup(true);
    }
  }, []);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Invoice-List-Add-Update").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  // window.onload = function(e) {
  //   if(e.type === "load"){
  //     window.localStorage.removeItem("asc_TypeAnItemPopup");
  //     console.log("asc56",e.type);
  //   }
  // };

  useEffect(() => {
    dispatch(FetchInvoiceList(companyId));
    dispatch(FetchLastCreditInvoiceCode(companyId));
    dispatch(FetchClient());
    // dispatch(ProjectDropdown());
    dispatch(Fetchproduct_Parts_List());
    dispatch(FetchPaymentDeadline());
    dispatch(FetchLastInvoiceCode(companyId));
    dispatch(FetchProjectById(projectId || locationState?.historyProjectid));
  }, []);

  useEffect(() => {
    if (fetchInvoiceAllListData.status === true) {
      // setRelatedInvoiceData(fetchInvoiceAllListData?.data);
      // let filterData = fetchInvoiceAllListData?.data?.filter(
      //   (x) => x.invoicestatus !== "Credit" && x.invoicestatus !== "Deleted"
      // );
      let filterData = fetchInvoiceAllListData?.data?.filter(
        (x) => x.invoicestatus === "Not Sent",
      );
      setRelatedInvoiceData(filterData);
    }
  }, [fetchInvoiceAllListData]);

  useEffect(() => {
    if (addCreditNoteResponse?.status === true) {
      dispatch({ type: ADD_CREDIT_NOTE, data: {} });
      if (locationData?.url === "/addProject") {
        history.push({ pathname: "/addProject", state: { tab: "Invoice" } });
      } else if (locationData?.url === "/InvoiceAllList") {
        history.push({ pathname: "/InvoiceAllList" });
      }
      window.location.reload();
    }
  }, [addCreditNoteResponse]);

  // fetch project by id res start
  useEffect(() => {
    if (fetchProjectById.status === true) {
      if (locationState === "from_project_invo") {
        setClientName(fetchProjectById.data[0]?.clientname || "");
        setClientid(fetchProjectById.data[0]?.clientid || "");
        setSearchProjectName(fetchProjectById.data[0]?.projectname);
        setProjectid(fetchProjectById.data[0]?.projectid);
        setPaymentDeadline(fetchProjectById.data[0]?.paymentTerms);
        setPaymentDeadlineid(fetchProjectById.data[0]?.paymentTermsId);
        setContactEmail(
          fetchProjectById.data[0]?.contactEmail ||
            fetchProjectById.data[0]?.clientemail,
        );
      }

      if (locationState?.from === "Quote_Screen") {
        setClientName(locationState.historyClientName);
        setClientid(locationState.historyClientid);
        setSearchProjectName(locationState.historyProjectName);
        setProjectid(locationState?.historyProjectid);
        setQuotecode(locationState.historyQuoteCode);
        setQuoteid(locationState.historyQuoteid);
        dispatch(FetchProductByQuotes(locationState.historyQuoteid));
      }

      dispatch(FetchProjectByClient(fetchProjectById.data[0]?.clientid));
    }
  }, [fetchProjectById]);
  // fetch project by id res end

  // asc client Responce start //
  useEffect(() => {
    if (fetchClient.status === true) {
      setClientData(fetchClient.data);
      if (locationState === "from_project_invo") {
        const localClient = fetchClient.data.findIndex(
          (x) => x.id === clientid,
        );
        if (localClient > -1) {
          setClientAddress(fetchClient.data[localClient]?.address);
          setClientCountry(fetchClient.data[localClient]?.country);
        }
      }
    }
  }, [fetchClient]);
  // asc client Responce end //

  // asc Quote Responce start //
  useEffect(() => {
    if (fetchQuotesResponse.status === true) {
      setQuotesData(fetchQuotesResponse.data);
      if (fetchQuotesResponse?.totalCount === 1) {
        setQuotecode(fetchQuotesResponse?.data[0]?.quotecode);
        setQuoteid(fetchQuotesResponse?.data[0]?.quoteid);
        dispatch(FetchProductByQuotes(fetchQuotesResponse?.data[0]?.quoteid));
      }
    }
  }, [fetchQuotesResponse]);
  // asc Quote Responce end //

  // asc fetch product part list Responce start //
  useEffect(() => {
    if (fetchProductPartList?.status === true) {
      setProductPartList(fetchProductPartList.data);
    }
  }, [fetchProductPartList]);
  // asc fetch product part list Responce end //

  // asc fetch project DropDown Responce start //
  useEffect(() => {
    if (fetchProjectByClientRes?.status === true) {
      setProjectsData(fetchProjectByClientRes?.data);
    }
  }, [fetchProjectByClientRes]);
  // asc fetch project DropDown Responce end //

  // asc fetch quotes related products Responce start //
  useEffect(() => {
    if (fetchProductsByQuotesRes?.status === true) {
      setQuotesProductsData(fetchProductsByQuotesRes?.data);

      // start item pushing...
      let invoiceListArray = [];

      fetchProductsByQuotesRes?.data.map((item) => {
        return invoiceListArray.push({
          asc_Name: item.productpartname,
          asc_productPartCode: item.itemid,
          asc_UnitPrice: item.salepriceexcvat,
          // asc_Total: item.salepriceexcvat * item.qty,
          asc_Total:
            item.salepriceexcvat * item.qty * (1 + (item.vat || 0) / 100),
          asc_ProductPartid: item.productPartid,
          asc_Qty: item.qty,
          asc_Disc: 0,
          asc_Vat: item.vat,
          asc_Suffix: item.suffix,
        });
      });
      setInvoiceList(invoiceListArray);
    }
  }, [fetchProductsByQuotesRes]);
  // asc fetch quotes related products Responce end //

  // fetch last credit note code Res start
  useEffect(() => {
    if (fetchLastCreditInvoiceCodeRes.status === true) {
      setLastCreditCode(fetchLastCreditInvoiceCodeRes.data);
    }
  }, [fetchLastCreditInvoiceCodeRes]);
  // fetch last credit note code Res end

  // asc add invoice Responce start //
  useEffect(() => {
    if (addInvoiceProject?.status === true) {
      showAlertForInvoiceAPIResponse(addInvoiceProject);
      // setApimessage("Added successfully");
      setSearchInvoiceName("");
      setSearchClientName("");
      setInvoiceName("");
      setInvoiceID("");
      setClientName("");
      setClientid("");
      setClientAddress("");
      setClientCountry("");
      setSearchProjectName("");
      setProjectid("");
      setQuotecode("");
      setQuoteid("");
      setPaymentDeadline("");
      setPaymentDeadlineid("");
      // setChooseOption("");
      setContactEmail("");
      setPoNumber("");
      setInvoiceStatus("");
      setNotes("");
      setInvoiceList([]);

      setTimeout(() => {
        setApimessage("");
        history.goBack();
      }, 2000);

      dispatch({
        type: ADD_INVOICE_PROJECT,
        data: {},
      });
    } else {
      setInvoiceList([]);

      if (addInvoiceProject.status === false) {
        showAlertForInvoiceAPIResponse(addInvoiceProject);
        // setApimessage("Something went Wrong");
        setTimeout(() => {
          setApimessage("");
        }, 3000);
      }
    }
  }, [addInvoiceProject]);
  // asc add invoice Responce end //

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const showAlertForInvoiceAPIResponse = (response) => {
    console.log(response);

    InvoiceNotification(response);

    // if (response?.status === true) {
    //   setApimessage("Added successfully");
    // }

    // else if (response?.status === false) {
    //   setApimessage("Something went Wrong");
    // }
  };

  const handleClickOutside = (event) => {
    if (
      Client_Popup_Ref.current &&
      !Client_Popup_Ref.current.contains(event.target)
    ) {
      setClientShowOptions(false);
      setArrowOptionsRotate(false);
    }

    if (
      Invoice_Popup_Ref.current &&
      !Invoice_Popup_Ref.current.contains(event.target)
    ) {
      setInvoiceShowOptions(false);
      setArrowOptionsRotate6(false);
    }

    if (
      Project_Popup_Ref.current &&
      !Project_Popup_Ref.current.contains(event.target)
    ) {
      setProjectShowOptions(false);
      setArrowOptionsRotate2(false);
    }

    if (
      quotes_Popup_Ref.current &&
      !quotes_Popup_Ref.current.contains(event.target)
    ) {
      setQuoteShowOptions(false);
      setArrowOptionsRotate3(false);
    }

    if (
      PaymentDeadline_Popup_Ref.current &&
      !PaymentDeadline_Popup_Ref.current.contains(event.target)
    ) {
      setPaymentDeadlineOptions(false);
      setArrowOptionsRotate4(false);
    }

    if (
      PaymentOptions_Popup_Ref.current &&
      !PaymentOptions_Popup_Ref.current.contains(event.target)
    ) {
      setPaymentOptionShow(false);
      setArrowOptionsRotate5(false);
    }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  // asc fetch payment Deadline Responce start //
  useEffect(() => {
    if (fetchPaymentDeadline?.status === true) {
      setPaymentDeadlineData(fetchPaymentDeadline?.data);
    }
  }, [fetchPaymentDeadline]);
  // asc fetch payment Deadline Responce end //

  const [duedate3, setDuedate3] = useState("");
  // asc Make New Invoice API start
  const handleMakeInvoiceAdd = (asc_invoiceStatus) => {
    // if (clientName === "" || searchProjectName === "" || quotecode === "") {
    //   return;
    // }

    if (clientName === "" || searchProjectName === "") {
      return;
    }

    let re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    // let asc_uniqueid = "id" + Math.random().toString(16).slice(2);
    // let asc_uniqueid2 = "id" + new Date().getTime();

    const invoicetotal = invoiceList.reduce((a, b) => (a = a + b.asc_Total), 0);

    const totalexclusivebtw = invoiceList.reduce(
      (a, b) => a + Number(b.asc_Qty * b.asc_UnitPrice),
      0,
    );

    const totalinclusivebtw = invoiceList.reduce((a, b) => a + b.asc_Total, 0);

    const array = [];
    for (let index = 0; index < invoiceList.length; index++) {
      // let asc_uniqueid = "id" + Math.random().toString(16).slice(2);
      let asc_uniqueid = uuidv4();
      array.push({
        productid: invoiceList[index].asc_ProductPartid,
        qty: invoiceList[index].asc_Qty ? invoiceList[index].asc_Qty : 0,
        vatpercent: invoiceList[index].asc_Vat ? invoiceList[index].asc_Vat : 0,
        discount: invoiceList[index].asc_Disc ? invoiceList[index].asc_Disc : 0,
        total: invoiceList[index].asc_Total,
        // total: europeanFormatWithSymbol(invoiceList[index].asc_Total),
        suffix: invoiceList[index].asc_Suffix,
        indexPosition: index,
      });
    }

    // const array2 = [];
    // invoiceList.map((item) => {
    //   array2.push({ assigneeid: item.assigneeid });
    // });

    let today2 = moment();
    let duedate2 = today2.add(paymentDeadline?.split(" ")[0], "days");
    let formattedDuedate = duedate2?.format("DD.MM.YYYY");

    // let trimText = notes.trim();

    // if (trimText === "") {
    //   setNotesWarning(true);
    // } else if (!re.test(contactEmail) && contactEmail) {
    //   // setEmailInvalid(true);
    // } else {

    if (
      invoiceList.some(
        (item) => item.asc_Name === "" || item.asc_productPartCode === "",
      )
    ) {
      setTypeAnItemWarn(true);
    } else {
      dispatch(
        AddCreditNote(
          invoiceID,
          projectid,
          quoteid || "00000000-0000-0000-0000-000000000000",
          companyId,
          lastCreditCode,
          poNumber,
          clientid,
          // paymentDeadline ? paymentDeadline : "0 Days",
          // duedate2,
          duedate3,
          // chooseOption ? chooseOption : "Bank Transfer",
          asc_invoiceStatus,
          notes,
          totalexclusivebtw,
          totalinclusivebtw,
          invoicetotal,
          array,
        ),
      );
    }
  };
  // asc Make New Invoice API end

  document.getElementById("asc_input")?.focus();

  // asc vat 9 and 21 % start
  let vat9 = invoiceList.filter((item) => item.asc_Vat === "9");
  let vat21 = invoiceList.filter((item) => item.asc_Vat === "21");
  // asc vat 9 and 21 % end

  const handleItemRowChange = (index, key, value) => {
    let oldItems = [...invoiceList];
    oldItems[index][key] = value;

    let qty = isNaN(oldItems[index]["asc_Qty"])
      ? 0
      : Number(oldItems[index]["asc_Qty"]);
    let price = isNaN(oldItems[index]["asc_UnitPrice"])
      ? 0
      : Number(oldItems[index]["asc_UnitPrice"]);
    let discount = isNaN(oldItems[index]["asc_Disc"])
      ? 0
      : Number(oldItems[index]["asc_Disc"]);
    let vat = isNaN(oldItems[index]["asc_Vat"])
      ? 0
      : Number(oldItems[index]["asc_Vat"]);

    let subTotal = qty * price;

    oldItems[index]["qty_total"] = subTotal;

    if (discount) {
      subTotal -= (subTotal * discount) / 100;
    }

    oldItems[index]["vat_amount"] = 0;
    if (vat) {
      let vatAmount = subTotal * (vat / 100);
      oldItems[index]["vat_amount"] = vatAmount;
      subTotal += vatAmount;
    }
    oldItems[index]["asc_Total"] = subTotal;

    setInvoiceList([...oldItems]);
  };

  // ASC Drag Drop start
  const handleDragEnd = (data) => {
    let tempDragData = Array.from(invoiceList);
    let [source_Data] = tempDragData.splice(data.source.index, 1);
    tempDragData.splice(data.destination.index, 0, source_Data);
    setInvoiceList(tempDragData);

    // for finding Droppable ids and indexes
    let draggableId = data.draggableId;
    let destinationDropId = data.destination.droppableId;
    let destinationIndex = data.destination.index;
    let sourceDropId = data.source.droppableId;
    let sourceIndex = data.source.index;

    // finding nearbyID using index
    let id22 = data.destination.index;
    let nearbyID = invoiceList.filter((item, index) => index === id22);

    // for sending in API below
    let payload = [
      {
        taskid: draggableId,
        indexPosition: destinationIndex,
      },
      // {
      //   taskid: sourceDropId,
      //   indexPosition: sourceIndex,
      // },
    ];

    // dispatch(updateOrdersIndexPositions(payload));
  };
  // ASC Drag Drop end

  return (
    <>
      {cancelPopupShow && (
        <CancelWarningModal
          show={cancelPopupShow}
          // onHide={() => setCancelPopupShow(false)}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          handleCancel={handleCancel}
        />
      )}

      <div className="newInvoiceMainDiv">
        <h6
          className={
            apimessage !== "Something went Wrong"
              ? "text-success fw-bold ps-4"
              : "text-danger fw-bold ps-4"
          }
          style={{
            transform: apimessage ? "scale(1)" : "scale(0)",
            transitionDuration: "500ms",
          }}
        >
          {apimessage}
        </h6>

        <section className="invoiceNrHeading gap-0">
          <div className="d-flex invoiceNrDiv py-2 px-4">
            <p className="mb-0 invoiceText">
              {/* CREDIT NOTE */}
              {t("CREDIT NOTE")}
            </p>
            <div className="d-flex flex-wrap align-items-center">
              <p className="NrTextBorder px-2 mb-0">{lastCreditCode}</p>
              <p className="px-2 mb-0 NrDate">
                {moment(today).format("DD.MM.YYYY")}
              </p>
            </div>
            <p className="mb-0 draftText">
              ({/* DRAFT */}
              {t("DRAFT")})
            </p>
          </div>

          <div className="d-flex flex-wrap gap-3 justify-content-end pt-5 pt-lg-5 pt-xl-0 threeButtons">
            <button
              className="mb-0 cancelBtn"
              onClick={() => {
                if (typeInScreen !== "") {
                  setCancelPopupShow(true);
                } else {
                  history.goBack();
                  // history.push("/InvoiceAllList");
                }
              }}
            >
              {/* Cancel */}
              {t("Cancel")}
            </button>
            <button
              className="mb-0 saveDraftBtn"
              onClick={() => {
                setInvoiceStatus("Draft");
                handleMakeInvoiceAdd("Draft");
                //checking client is selected for  error warning
                if (clientName == "") {
                  setclientFlag(true);
                  // return;
                } else {
                  setclientFlag(false);
                }
                //checking project is selected for  error warning
                if (searchProjectName == "") {
                  setProjectFlag(true);
                  // return;
                } else {
                  setProjectFlag(false);
                }
                //checking quote is selected for error warning
                if (quotecode == "") {
                  // setQuoteFlag(true);
                } else {
                  setQuoteFlag(false);
                }

                // setTimeout(() => {
                //   history.goBack();
                // }, 3000);
              }}
            >
              {/* Save Draft */}
              {t("Save draft")}
            </button>
            <button
              className="mb-0 makeInvoBtn"
              onClick={() => {
                setInvoiceStatus("Credit");
                handleMakeInvoiceAdd("Credit");

                //checking client is selected for  error warning
                if (clientName == "") {
                  setclientFlag(true);
                  // return;
                } else {
                  setclientFlag(false);
                }
                //checking project is selected for  error warning
                if (searchProjectName == "") {
                  setProjectFlag(true);
                  // return;
                } else {
                  setProjectFlag(false);
                }
                //checking quote is selected for error warning
                if (quotecode == "") {
                  // setQuoteFlag(true);
                } else {
                  setQuoteFlag(false);
                }

                // setTimeout(() => {
                //   history.goBack();
                // }, 3000);
              }}
            >
              {/* Make Credit */}
              {t("Make Credit")}
            </button>
          </div>
        </section>

        <section
          className="sectionInputs d-fle-x justify-content-center justify-content-xl-between flex-wrap gap-3 my-3 pb-4 px-4"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          }}
        >
          <div className="">
            <div
              className="asc-input-container"
              id="ascInput"
              style={{ backgroundColor: "#ffffff" }}
            >
              <label className="asc-label-top ClientNameText">
                {/* Invoice Related */}
                {t("Invoice Related")}
                <span style={{ color: "red" }}>*</span>
              </label>
              <div
                className="asc_Client_Input_Div_For_LongDiv22 d-flex pointer w-auto"
                ref={Invoice_Popup_Ref}
              >
                <p
                  className="asc_Client_Input_For_Long ps-3"
                  onClick={() => {
                    setInvoiceShowOptions(true);
                    setArrowOptionsRotate6(true);
                  }}
                >
                  {/* {invoiceName ? invoiceName : "Select Invoice"} */}
                  {invoiceName ? invoiceName : t("Select Invoice")}
                </p>

                {invoiceName ? (
                  <img
                    src={Xicon}
                    className="xicon pointer"
                    alt=""
                    onClick={() => {
                      setSearchInvoiceName("");
                      setInvoiceName("");
                      setInvoiceID("");
                      setClientName("");
                      setClientid("");
                      setClientAddress("");
                      setClientCountry("");
                      setTypeInScreen("asc");
                      // setClientShowOptions(false);
                      // setShowOptions(!showOptions);
                      setSearchProjectName("");
                      setProjectid("");
                      setQuotecode("");
                      setQuoteid("");
                      setPoNumber("");
                      setContactEmail("");
                    }}
                  />
                ) : (
                  <img
                    src={DownArrowOption}
                    className={arrowOptionsRotate6 ? "upArrow" : "downArrow"}
                    alt=""
                    onClick={() => {
                      setInvoiceShowOptions(true);
                      setArrowOptionsRotate6(true);
                    }}
                  />
                )}

                {invoiceShowOptions && (
                  <div
                    className="asc_Custom_Select_Outer22"
                    style={{
                      transform: invoiceShowOptions ? "scale(1)" : "scale(0)",
                      transitionDuration: "300ms",
                    }}
                  >
                    <p className="asc_Search_Client_Text pt-2 ps-2">
                      Search Invoice
                      {/* {FetchTranslationList[90]?.translation} */}
                    </p>
                    <section className="asc_Search_Icon_Search mx-2">
                      <img
                        src={searchicon}
                        className="asc_searchicon"
                        alt="Search Icon"
                      />
                      <input
                        id="asc_input"
                        className="asc_Search_Input"
                        placeholder="Search..."
                        value={searchInvoiceName}
                        onChange={(e) => setSearchInvoiceName(e.target.value)}
                      />
                    </section>

                    <section
                      className="asc_Search_List pt-0 ps-0"
                      id="ascSelectBox"
                    >
                      {relatedInvoiceData
                        .filter((item) =>
                          item.projectcode
                            ?.toLowerCase()
                            .includes(searchInvoiceName.toLowerCase()),
                        )
                        .map((item, index) => {
                          return (
                            <div
                              key={index}
                              className="ulterDrop"
                              onClick={async () => {
                                setSearchInvoiceName("");
                                setInvoiceName(
                                  `${item.projectcode} | ${moment(
                                    item?.createdat,
                                  ).format("MM.DD.YYYY")}`,
                                );
                                setInvoiceID(item.invoiceid);
                                setInvoiceShowOptions(false);

                                setClientName(item.clientname);
                                setClientid(item.clientid);
                                setSearchProjectName(item.projectname);
                                setProjectid(item.projectid);
                                setPoNumber(item.poNumber);

                                const res = await dispatch(
                                  FetchInvoiceByInvoiceId(item.invoiceid),
                                );
                                if (res.status === true) {
                                  setQuoteid(res?.data[0]?.quoteid);
                                  setQuotecode(res?.data[0]?.quotecode);
                                  setContactEmail(
                                    res?.data[0]?.client[0]?.clientname,
                                  );
                                  setChooseOption(res?.data[0]?.paymentoptions);
                                  setPaymentDeadline(
                                    res?.data[0]?.paymentdeadline,
                                  );
                                  setDuedate3(res?.data[0]?.duedate);
                                  dispatch(
                                    FetchProductByQuotes(res?.data[0]?.quoteid),
                                  );
                                }
                                // dispatch(FetchProjectByClient(item.id));
                              }}
                            >
                              <p
                                className={
                                  invoiceID === item.invoiceid
                                    ? "asc_Selected_Item mb-0"
                                    : "mb-0"
                                }
                              >
                                {item.projectcode} |{" "}
                                {moment(item?.createdat).format("DD.MM.YYYY")}
                              </p>
                            </div>
                          );
                        })}
                      {relatedInvoiceData.length === 0 && (
                        <span className="noDataDisplay">
                          {/* No data to display! */}
                          {t("No data to display!")}
                          {/* {FetchTranslationList?.data?.data[94]?.translation} */}
                        </span>
                      )}
                    </section>
                  </div>
                )}
              </div>
              {/* show warning for cedit note  gaurav start*/}
              {clientFlag && (
                <p style={{ color: "red", fontSize: "10px" }}>
                  Please select invoice first!
                  {/* {FetchTranslationList[92]?.translation} */}
                </p>
              )}
              {/* show warning for cedit note gaurav end*/}
            </div>
          </div>

          <div style={{ pointerEvents: "none" }}>
            <div className="asc-input-container" id="ascInput">
              <label className="asc-label-top ClientNameText">
                {/* Client */}
                {t("Client")}
                <span style={{ color: "red" }}>*</span>
              </label>
              <div
                className="asc_Client_Input_Div_For_LongDiv d-flex w-100"
                ref={Client_Popup_Ref}
              >
                {/* <input
                  type="text"
                  className="asc_Client_Input_For_Long ps-3"
                  placeholder="Select Client"
                  value={searchClientName}
                  onChange={(e) => {
                    setSearchClientName(e.target.value);
                    setClientShowOptions(true);
                  }}
                  onFocus={() => {
                    setClientShowOptions(true);
                    setArrowOptionsRotate(true);
                  }}
                /> */}

                <p
                  className="asc_Client_Input_For_Long ps-3"
                  onClick={() => {
                    setClientShowOptions(true);
                    setArrowOptionsRotate(true);
                  }}
                >
                  {/* {clientName ? clientName : "Select Client"} */}
                  {clientName ? clientName : t("Select Client")}

                  <br />
                  <p className="clintAddress pt-2">{clientAddress}</p>
                  <p className="clintAddress">{clientCountry}</p>
                </p>

                {clientName ? (
                  <img
                    src={Xicon}
                    className="xicon pointer"
                    alt=""
                    onClick={() => {
                      setSearchClientName("");
                      setClientName("");
                      setClientid("");
                      setClientAddress("");
                      setClientCountry("");
                      setTypeInScreen("asc");
                      // setClientShowOptions(false);
                      // setShowOptions(!showOptions);
                      setSearchProjectName("");
                      setProjectid("");
                      setQuotecode("");
                      setQuoteid("");
                    }}
                  />
                ) : (
                  <img
                    src={DownArrowOption}
                    className={arrowOptionsRotate ? "upArrow" : "downArrow"}
                    alt=""
                    onClick={() => {
                      setClientShowOptions(true);
                      setArrowOptionsRotate(true);
                    }}
                  />
                )}

                {clientShowOptions && (
                  <div
                    className="asc_Custom_Select_Outer22"
                    style={{
                      transform: clientShowOptions ? "scale(1)" : "scale(0)",
                      transitionDuration: "300ms",
                    }}
                  >
                    <p className="asc_Search_Client_Text pt-2 ps-2">
                      {/* Search Client */}
                      {t("Search Client")}
                    </p>
                    <section className="asc_Search_Icon_Search mx-2">
                      <img
                        src={searchicon}
                        className="asc_searchicon"
                        alt="Search Icon"
                      />
                      <input
                        id="asc_input"
                        className="asc_Search_Input"
                        placeholder="Search..."
                        value={searchClientName}
                        onChange={(e) => setSearchClientName(e.target.value)}
                      />
                    </section>

                    <section
                      className="asc_Search_List pt-0 p-3"
                      id="ascSelectBox"
                    >
                      {clientData
                        .filter((item) =>
                          item.name
                            ?.toLowerCase()
                            .includes(searchClientName.toLowerCase()),
                        )
                        .map((item, index) => {
                          return (
                            <div
                              key={index}
                              className=""
                              onClick={() => {
                                setSearchClientName("");
                                setClientName(item.name);
                                setClientid(item.id);
                                // dispatch(FetchProjectByClient(item.id));
                                setClientAddress(item.address);
                                setContactEmail(item.email);
                                // setProfessionalAddress(item.professionalAddress);
                                // setPersonalAddress(item.personalAddress);
                                // setZipCode(item.zipCode);
                                // setCity(item.city);
                                setClientCountry(item.country);
                                setClientShowOptions(false);
                                setTypeInScreen("asc");
                                setclientFlag(false); // client error warning
                              }}
                            >
                              <p
                                className={
                                  clientid === item.id
                                    ? "asc_Selected_Item ps-3"
                                    : "ps-3"
                                }
                              >
                                {item.name}
                              </p>
                            </div>
                          );
                        })}
                      {clientData.length === 0 && (
                        <span className="noDataDisplay">
                          {/* No data to display! */}
                          {t("No data to display!")}
                          {/* {FetchTranslationList?.data?.data[94]?.translation} */}
                        </span>
                      )}
                    </section>
                  </div>
                )}
              </div>
              {/* show warning for client  gaurav start*/}
              {clientFlag && (
                <p style={{ color: "red", fontSize: "10px" }}>
                  {/* Please select client first! */}
                  {t("Please select client first!")}
                </p>
              )}
              {/* show warning for client  gaurav end*/}
            </div>

            <div className="asc-input-container" id="ascInput">
              <label className="asc-label-top ClientNameText">
                {/* Client Email */}
                {t("Client Email")}
              </label>
              <input
                type="email"
                // disabled
                className="asc_NormalInput ps-4 w-100"
                placeholder="Email"
                value={contactEmail}
                // onChange={(e) => {
                //   setContactEmail(e.target.value);
                //   setTypeInScreen("asc");
                // }}
              />
            </div>
          </div>

          <div style={{ pointerEvents: "none" }}>
            <div className="asc-input-container" id="ascInput">
              <label className="asc-label-top ClientNameText">
                {/* Project */}
                {t("Project")}
                <span style={{ color: "red" }}>*</span>
              </label>
              <div
                className="asc_Client_Input_Div_For_LongDiv22 w-auto"
                ref={Project_Popup_Ref}
              >
                <input
                  type="text"
                  className="asc_Client_Input_For_Long ps-4"
                  // placeholder="Select Project"
                  placeholder={t("Select Project")}
                  value={searchProjectName}
                  onChange={(e) => {
                    setSearchProjectName(e.target.value);
                    setProjectShowOptions(true);
                  }}
                  onFocus={() => {
                    setProjectShowOptions(true);
                    setArrowOptionsRotate2(true);
                  }}
                />

                {searchProjectName ? (
                  <img
                    src={Xicon}
                    className="xicon pointer"
                    alt=""
                    onClick={() => {
                      setSearchProjectName("");
                      setProjectid("");
                      setTypeInScreen("asc");
                    }}
                  />
                ) : (
                  <img
                    src={DownArrowOption}
                    className={arrowOptionsRotate2 ? "upArrow" : "downArrow"}
                    alt=""
                    onClick={() => {
                      setProjectShowOptions(true);
                      setArrowOptionsRotate2(true);
                    }}
                  />
                )}

                {projectShowOptions && (
                  <div
                    className="asc_Custom_Select_Outer_Project"
                    style={{
                      transform: projectShowOptions ? "scale(1)" : "scale(0)",
                      transitionDuration: "300ms",
                    }}
                  >
                    <p className="asc_Search_Client_Text pt-2 ps-3 pb-3">
                      {/* Select Project */}
                      {t("Select Project")}
                    </p>
                    {/* <section className="asc_Search_Icon_Search mx-2">
                      <img
                        src={searchicon}
                        className="asc_searchicon"
                        alt="Search Icon"
                      />
                      <input
                        className="asc_Search_Input"
                        placeholder="Search..."
                        value={searchProjectName}
                        onChange={(e) => setSearchProjectName(e.target.value)}
                      />
                    </section> */}

                    <section
                      className="asc_Search_List_Project pt-0 p-3"
                      id="ascSelectBox"
                    >
                      {projectsData.map((item, index) => {
                        return (
                          <div
                            key={index}
                            className=""
                            onClick={() => {
                              setSearchProjectName(item.projectname);
                              setProjectid(item.projectid);
                              setContactEmail(item.contactemail);
                              // dispatch(
                              //   FetchQuotes(
                              //     // projectid,
                              //     item.projectid,
                              //     pageNumber,
                              //     itemsPerPage
                              //   )
                              // );
                              setPaymentDeadline(item.paymentdeadline ?? "");
                              setPaymentDeadlineid(item.paymentTerms ?? "");
                              setProjectShowOptions(false);
                              setTypeInScreen("asc");
                              setProjectFlag(false); // project error warning
                            }}
                          >
                            <p className="ps-3">{item.projectname}</p>
                          </div>
                        );
                      })}
                      {projectsData.length === 0 && (
                        <span className="noDataDisplay">
                          {/* No data to display! */}
                          {t("No data to display!")}
                          {/* {FetchTranslationList?.data?.data[94]?.translation} */}
                        </span>
                      )}
                    </section>
                  </div>
                )}
              </div>
              {/* show warning for project  gaurav start*/}
              {projectFlag && (
                <p style={{ color: "red", fontSize: "10px" }}>
                  {/* Please select project first! */}
                  {t("Please select project first!")}
                </p>
              )}
              {/* show warning for project  gaurav end*/}
            </div>

            <div className="asc-input-container" id="ascInput">
              <label className="asc-label-top ClientNameText">
                {/* Quote */}
                {t("Quote")}
                <span style={{ color: "red" }}>*</span>
              </label>
              <div
                className="asc_Client_Input_Div_For_LongDiv22 w-auto"
                ref={quotes_Popup_Ref}
              >
                <input
                  type="text"
                  className="asc_Client_Input_For_Long ps-4"
                  // placeholder="Select Quote"
                  placeholder={t("Select Quote")}
                  value={quotecode}
                  onChange={(e) => {
                    setQuotecode(e.target.value);
                    setQuoteShowOptions(true);
                    setClientWarning(false);
                  }}
                  onFocus={() => {
                    setQuoteShowOptions(true);
                    setArrowOptionsRotate3(true);
                  }}
                />

                {quotecode ? (
                  <img
                    src={Xicon}
                    className="xicon pointer"
                    alt=""
                    onClick={() => {
                      setQuotecode("");
                      setQuoteid("");
                      setTypeInScreen("asc");
                      setInvoiceList([]);
                    }}
                  />
                ) : (
                  <img
                    src={DownArrowOption}
                    className={arrowOptionsRotate3 ? "upArrow" : "downArrow"}
                    alt=""
                    onClick={() => {
                      setQuoteShowOptions(true);
                      setArrowOptionsRotate3(true);
                    }}
                  />
                )}

                {quoteShowOptions && (
                  <div
                    className="asc_Custom_Select_Outer_Project"
                    style={{
                      transform: quoteShowOptions ? "scale(1)" : "scale(0)",
                      transitionDuration: "300ms",
                    }}
                  >
                    <p className="asc_Search_Client_Text pt-2 ps-3 pb-3">
                      {/* Select Quote */}
                      {t("Select Quote")}
                    </p>
                    {/* <section className="asc_Search_Icon_Search mx-2">
                      <img
                        src={searchicon}
                        className="asc_searchicon"
                        alt="Search Icon"
                      />
                      <input
                        className="asc_Search_Input"
                        placeholder="Search..."
                        value={quotecode}
                        onChange={(e) => setQuotecode(e.target.value)}
                      />
                    </section> */}

                    <section
                      className="asc_Search_List_Project pt-0 p-3"
                      id="ascSelectBox"
                    >
                      {quotesData.map((item, index) => {
                        return (
                          <div
                            key={index}
                            className=""
                            onClick={() => {
                              setQuotecode(item.quotecode);
                              setQuoteid(item.quoteid);
                              dispatch(FetchProductByQuotes(item.quoteid));
                              setQuoteShowOptions(false);
                              setTypeInScreen("asc");
                              setQuoteFlag(false); // quote error warning
                            }}
                          >
                            {item.quotecode}
                          </div>
                        );
                      })}
                      {quotesData.length === 0 && (
                        <span className="noDataDisplay">
                          {/* No data to display! */}
                          {t("No data to display!")}
                          {/* {FetchTranslationList?.data?.data[94]?.translation} */}
                        </span>
                      )}
                    </section>
                  </div>
                )}
              </div>
              {/* show warning for quote  gaurav start*/}
              {quoteFlag && (
                <p style={{ color: "red", fontSize: "10px" }}>
                  {/* Please select quote first! */}
                  {t("Please select quote first!")}
                </p>
              )}
              {/* show warning for quote  gaurav end*/}
            </div>

            <div className="asc-input-container" id="ascInput">
              <label className="asc-label-top ClientNameText">
                {/* PO Number */}
                {t("PO Number")}
              </label>
              <input
                type="number"
                className="asc_NormalInput ps-4 w-100"
                // placeholder="PO Number"
                placeholder={t("PO Number")}
                value={poNumber}
                onChange={(e) => {
                  setPoNumber(e.target.value);
                  setTypeInScreen("asc");
                }}
              />
            </div>
          </div>
        </section>

        <section>
          <div className="ascTableWrapper h-auto">
            {/* ASC Drag Drop srart */}
            <DragDropContext onDragEnd={handleDragEnd}>
              <table className="table">
                <thead>
                  <tr className="tableHeading-NewInvoice">
                    <th></th>
                    <th>
                      {/* ITEM ID */}
                      {t("ITEM ID")}
                    </th>
                    <th>
                      {/* ITEM DESCRIPTION */}
                      {t("ITEM Description")}
                    </th>
                    <th>
                      {/* QTY */}
                      {t("QTY")}
                    </th>
                    <th>
                      {/* U.PRICE */}
                      {t("U.PRICE")}
                    </th>
                    <th>
                      {/* DISCOUNT */}
                      {t("DISCOUNT")}
                    </th>
                    <th>
                      {/* VAT */}
                      {t("VAT")}%
                    </th>
                    <th>
                      {/* TOTAL */}
                      {t("TOTAL")}
                    </th>
                  </tr>
                </thead>

                <Droppable droppableId="index">
                  {(provider) => (
                    <tbody
                      className="tabLine"
                      style={{ borderTop: "none" }}
                      ref={provider.innerRef}
                      {...provider.droppableProps}
                    >
                      {invoiceList.map((item, index) => {
                        return (
                          <Draggable
                            key={item.asc_ProductPartid}
                            draggableId={item.asc_ProductPartid}
                            index={index}
                          >
                            {(provider) => (
                              <tr
                                {...provider.draggableProps}
                                {...provider.dragHandleProps}
                                ref={provider.innerRef}
                                className="TableRowClass"
                              >
                                <td className="align-content-center">=</td>

                                {item.asc_Name && item.asc_ProductPartid ? (
                                  <td
                                    className="align-content-center productInMultiLine"
                                    style={{ width: "150px" }}
                                  >
                                    {item.asc_productPartCode}
                                  </td>
                                ) : (
                                  <td key={index}>
                                    <input
                                      type="text"
                                      className="invoiceTypeItem"
                                      placeholder="Type product Code"
                                      value={item.asc_productPartCode}
                                      onChange={(e) => {
                                        let changeItemName = [...invoiceList];
                                        changeItemName[index][
                                          "asc_productPartCode"
                                        ] = e.target.value;
                                        setInvoiceList(changeItemName);
                                      }}
                                      // onFocus={() => {}}
                                    />
                                    {typeAnItemWarn &&
                                      item.asc_productPartCode === "" && (
                                        <p className="text-danger mb-0">
                                          {/* Please fill item id */}
                                          {t("Please fill item id")}
                                        </p>
                                      )}
                                  </td>
                                )}

                                {item.asc_Name && item.asc_ProductPartid ? (
                                  <div className="d-flex">
                                    <td
                                      className="productInMultiLine"
                                      style={{ minWidth: "175px" }}
                                    >
                                      {item.asc_Name}
                                    </td>
                                    <input
                                      type="text"
                                      style={{ border: "none" }}
                                      value={item?.asc_Suffix}
                                      onChange={(e) => {
                                        // "handleChange2"(e, "suffix", index)
                                        let changeItemName = [...invoiceList];
                                        changeItemName[index]["asc_Suffix"] =
                                          e.target.value;
                                        setInvoiceList(changeItemName);
                                      }}
                                    />
                                  </div>
                                ) : (
                                  <td key={index}>
                                    <input
                                      type="text"
                                      className="invoiceTypeItem"
                                      placeholder="Type an item"
                                      value={item.asc_Name}
                                      onChange={(e) => {
                                        let changeItemName = [...invoiceList];
                                        changeItemName[index]["asc_Name"] =
                                          e.target.value;
                                        setInvoiceList(changeItemName);
                                      }}
                                      // onFocus={() => {}}
                                    />
                                    {typeAnItemWarn && item.asc_Name === "" && (
                                      <p className="text-danger mb-0">
                                        {/* Please fill item */}
                                        {t("Please fill item")}
                                      </p>
                                    )}
                                  </td>
                                )}

                                <td
                                  className="ps-2 align-content-center"
                                  style={{ width: "10%" }}
                                >
                                  <input
                                    type="number"
                                    min={0}
                                    className="invoiceTypeItem w-75"
                                    placeholder="0"
                                    value={item.asc_Qty}
                                    onChange={(e) => {
                                      // let changeItemName = [...invoiceList];
                                      // changeItemName[index]["asc_Qty"] = e.target.value;
                                      // changeItemName[index]["asc_Total"] =
                                      //   changeItemName[index]["asc_UnitPrice"] *
                                      //   e.target.value;
                                      // setInvoiceList(changeItemName);

                                      handleItemRowChange(
                                        index,
                                        "asc_Qty",
                                        e.target.value,
                                      );
                                    }}
                                  />
                                </td>

                                {item.asc_Name && item.asc_ProductPartid ? (
                                  <td className="align-content-center">
                                    {europeanFormatWithSymbol(
                                      item.asc_UnitPrice,
                                    )}
                                  </td>
                                ) : (
                                  <td className="" style={{ width: "15%" }}>
                                    <input
                                      type="number"
                                      min={0}
                                      className="invoiceTypeItem w-75"
                                      placeholder="0"
                                      value={item.asc_UnitPrice}
                                      onChange={(e) => {
                                        // let changeItemName = [...invoiceList];
                                        // changeItemName[index]["asc_UnitPrice"] =
                                        //   e.target.value;
                                        // setInvoiceList(changeItemName);
                                        handleItemRowChange(
                                          index,
                                          "asc_UnitPrice",
                                          e.target.value,
                                        );
                                      }}
                                    />

                                    {/* <EuropeanInput
                            className="purchSupplierCode asc"
                            hidePreview={true}
                            value={item.asc_UnitPrice}
                            onChange={(e) => {
                              let changeItemName = [...invoiceList];
                              changeItemName[index]["asc_UnitPrice"] =
                                e.target.value;

                              setInvoiceList(changeItemName);
                            }}
                            withoutSymbol={true}
                          /> */}
                                  </td>
                                )}

                                <td
                                  className="align-content-center"
                                  style={{ width: "10%" }}
                                >
                                  <input
                                    type="number"
                                    min={0}
                                    className="invoiceTypeItem w-75"
                                    placeholder="0"
                                    value={item.asc_Disc}
                                    onChange={(e) => {
                                      // let changeItemName = [...invoiceList];
                                      // let disc = e.target.value;
                                      // changeItemName[index]["asc_Disc"] = disc;
                                      // changeItemName[index]["asc_Total"] =
                                      //   item.asc_Qty * item.asc_UnitPrice -
                                      //   (item.asc_Qty * item.asc_UnitPrice * disc) / 100;
                                      // setInvoiceList(changeItemName);

                                      handleItemRowChange(
                                        index,
                                        "asc_Disc",
                                        e.target.value,
                                      );
                                    }}
                                  />
                                </td>

                                <td
                                  className="align-content-center"
                                  style={{ width: "10%" }}
                                >
                                  {/* <input
                          type="number"
                          min={0}
                          className="invoiceTypeItem w-75"
                          placeholder="0"
                          value={item.asc_Vat}
                          onChange={(e) => {
                            handleItemRowChange(
                              index,
                              "asc_Vat",
                              e.target.value
                            );
                          }}
                        /> */}

                                  <select
                                    className="selectVat"
                                    name="cars"
                                    id="cars"
                                    onChange={(e) => {
                                      handleItemRowChange(
                                        index,
                                        "asc_Vat",
                                        e.target.value,
                                      );
                                    }}
                                    value={item.asc_Vat}
                                  >
                                    <option value="0">0</option>
                                    <option value="9">9</option>
                                    <option value="21">21</option>
                                  </select>
                                </td>

                                <td className="align-content-center">
                                  {europeanFormatWithSymbol(item.asc_Total)}
                                </td>
                                <td className="align-content-center">
                                  <img
                                    src={DeleteIcon}
                                    className="pointer"
                                    alt=""
                                    onClick={() => {
                                      let data = [...invoiceList];
                                      data.splice(index, 1);
                                      setInvoiceList(data);
                                    }}
                                  />
                                </td>
                              </tr>
                            )}
                          </Draggable>
                        );
                      })}
                      {provider.placeholder}

                      {/* Stable Table Row Below */}
                      <tr className="TableRowClass_stable">
                        <td>=</td>
                        <td></td>
                        <td>
                          <input
                            type="text"
                            className="invoiceTypeItem"
                            // placeholder="Type an item"
                            placeholder={t("Type an item")}
                            value={typeanItem}
                            onChange={(e) => {
                              setTypeanItem(e.target.value);
                              // setShowProductsPeople(true);
                            }}
                            onFocus={() => {
                              setTypeAnItemPopup(true);
                              // setProductsSearchPeople("");
                              setTypeInScreen("asc");
                            }}
                          />
                        </td>

                        <td className="ps-2">0</td>
                        <td>€ 0,00</td>
                        <td>0,00%</td>
                        <td>0,00</td>
                        <td>€ 0,00</td>
                        <td></td>

                        {/* <td
                    className="pointer"
                    onClick={() => {
                      let invoiceListArray = [...invoiceList];
                      invoiceListArray.push({
                        asc_Name: typeanItem,
                        asc_Qty: item.address,
                      });
                       setInvoiceList(invoiceListArray);
                      setTypeanItem("");
                    }}
                  >
                    if we want a new Row by click on Add 
                    ADD
                  </td> */}
                      </tr>
                    </tbody>
                  )}
                </Droppable>
              </table>
            </DragDropContext>
            {/* ASC Drag Drop end */}
          </div>
        </section>

        <section>
          <div className="row flex-column-reverse flex-lg-row commentsDiv mt-5">
            <div
              className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-7 col-xxl-7 asc-input-container mt-3"
              id="ascInput"
            >
              <label className="asc-label-top ClientNameText">
                {/* Notes */}
                {t("Notes")}
              </label>
              <div className="asc_Client_Input_Div_For_LongDiv">
                <textarea
                  id="w3review"
                  name="w3review"
                  // rows="4"
                  // cols="50"
                  rows="5"
                  cols="40"
                  // placeholder="Notes"
                  placeholder={t("Notes")}
                  className="asc_Client_Input_For_Long ps-3"
                  value={notes}
                  onChange={(e) => {
                    setNotes(e.target.value);
                    setTypeInScreen("asc");
                  }}
                ></textarea>
              </div>
            </div>

            <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-5 col-xxl-5">
              <div className="row totalDiv mt-3 position-relative">
                <div className="totalBg"></div>
                <div
                  className="d-flex flex-column align-items-end"
                  style={{
                    width: "45%",
                    marginRight: "40px",
                    marginLeft: "-41px",
                  }}
                >
                  <p className="mb-0 ps-4">
                    {/* TOTAL EXC. VAT */}
                    {t("TOTAL EXC. VAT")}
                  </p>
                  <p className="mb-0 ps-4">
                    {/* DISCOUNT */}
                    {t("DISCOUNT")}
                  </p>
                  <p className="mb-0 ps-5">
                    {/* VAT */}
                    {t("VAT")}
                  </p>
                  <p className="mb-0 ps-5">
                    {/* VAT */}
                    {t("VAT")}
                  </p>
                  <p className="mb-0 ps-5">
                    {/* VAT */}
                    {t("VAT")}
                  </p>
                  <p className="mb-0 ps-5 totalText">
                    {/* TOTAL */}
                    {t("TOTAL")}
                  </p>
                </div>

                <div className="w-25">
                  <p className="mb-0 invisible">ASC</p>
                  <p className="mb-0 invisible">ASC</p>
                  <p className="mb-0">0,00</p>
                  <p className="mb-0">9,00</p>
                  <p className="mb-0">21,00</p>
                  <p className="mb-0 totalText2"></p>
                </div>

                <div className="" style={{ width: "30%" }}>
                  <p className="mb-0">
                    {europeanFormatWithSymbol(
                      invoiceList.reduce(
                        (a, b) => a + Number(b.asc_Qty * b.asc_UnitPrice),
                        0,
                      ),
                    )}
                  </p>
                  <p className="mb-0">
                    {europeanFormatWithSymbol(
                      invoiceList.reduce(
                        (a, b) =>
                          a +
                          Number(
                            (b.asc_Qty * b.asc_UnitPrice * b.asc_Disc) / 100,
                          ),
                        0,
                      ),
                    )}
                  </p>
                  <p className="mb-0">€ 0,00</p>
                  <p className="mb-0">
                    {/* {europeanFormatWithSymbol(
                      vat9.reduce((a, b) => a + b.vat_amount, 0)
                    )} */}

                    {europeanFormatWithSymbol(
                      invoiceList
                        .filter((item) => item.asc_Vat === "9")
                        .reduce(
                          (total, item) =>
                            total +
                            (Number(item.asc_UnitPrice) *
                              Number(item.asc_Qty) *
                              9) /
                              100,
                          0,
                        ),
                    )}
                  </p>
                  <p className="mb-0">
                    {/* {europeanFormatWithSymbol(
                      vat21.reduce((a, b) => a + b.vat_amount, 0)
                    )} */}

                    {europeanFormatWithSymbol(
                      invoiceList
                        .filter((item) => item.asc_Vat === "21")
                        .reduce(
                          (total, item) =>
                            total +
                            (Number(item.asc_UnitPrice) *
                              Number(item.asc_Qty) *
                              21) /
                              100,
                          0,
                        ),
                    )}
                  </p>
                  <p className="mb-0 totalText">
                    {europeanFormatWithSymbol(
                      invoiceList.reduce((a, b) => a + b.asc_Total, 0),
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* SEND PROPS DATA TO TYPE AN ITEM POPUP */}
      <TypeItemPopupBox
        typeAnItemPopup={typeAnItemPopup}
        setTypeAnItemPopup={setTypeAnItemPopup}
        invoiceList={invoiceList}
        setInvoiceList={setInvoiceList}
        productPartList={productPartList}
        setProductPartList={setProductPartList}
      />
    </>
  );
};

// ASC TYPE AN ITEM POPUP START //
const TypeItemPopupBox = ({
  typeAnItemPopup,
  setTypeAnItemPopup,
  invoiceList,
  setInvoiceList,
  productPartList,
  setProductPartList,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const typeAnItemPopup_Ref = useRef(null);

  const [productPartid, setProductPartid] = useState("");
  const [productSearchName, setProductSearchName] = useState("");
  const [addTextField, setAddTextField] = useState(false);
  const [newTextField, setNewTextField] = useState("");

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Invoice-List-Add-Update").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const handleClickOutside = (event) => {
    if (
      typeAnItemPopup_Ref.current &&
      !typeAnItemPopup_Ref.current.contains(event.target)
    ) {
      setTypeAnItemPopup(false);
      // setArrowOptionsRotate(false);
    }

    // if (type_an_item_Drop_Ref.current && !type_an_item_Drop_Ref.current.contains(event.target)) {
    //   setShowProductsPeople(false);
    // }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  return (
    <section style={{ display: "flex", justifyContent: "center" }}>
      <div
        className="asc_Custom_Select_Outer_Invoice"
        style={{
          transform: typeAnItemPopup ? "scale(1)" : "scale(0)",
          transitionDuration: "300ms",
        }}
      >
        <div className="PopupHeader">
          <p className="asc_Search_Client_Text_Invoice pt-2 ps-2">
            {/* Products & Parts */}
            {t("TOTAL EXC. VAT")}
          </p>
          <section className="asc_Search_Icon_Search_Invoice mx-2">
            <input
              className="asc_Search_Input_Invoice"
              placeholder="Search..."
              value={productSearchName}
              onChange={(e) => setProductSearchName(e.target.value)}
            />
            <img
              src={searchicon}
              className="asc_searchicon_Invoice me-2"
              alt="Search Icon"
            />
          </section>

          <div
            className="d-flex flex-wrap gap-2 addProduct pointer"
            onClick={() => {
              history.push("/add-part");
              window.localStorage.setItem("asc_TypeAnItemPopup", true);
            }}
          >
            <img src={blueAddButton} alt="" />
            <p className="mb-0 pt-1">
              {/* Add Product/Part */}
              {t("Products & Parts")}
            </p>
          </div>

          <div
            className="d-flex flex-wrap gap-2 addProduct pointer"
            style={{ position: "relative" }}
            // onClick={() => setAddTextField(true)}
            onClick={() => {
              // start item pushing...
              let invoiceListArray = [...invoiceList];
              invoiceListArray.push({
                asc_Name: "",
                asc_productPartCode: "",
                asc_Qty: 1,
                asc_Disc: 0,
                asc_Vat: 0,
              });
              setInvoiceList(invoiceListArray);

              setNewTextField("");
            }}
          >
            <img src={greyAddButton} alt="" />
            <p className="mb-0 pt-1">
              {/* Add Text Field */}
              {t("Add Product/Part")}
            </p>
          </div>

          <div>
            <h6
              className="xCiecle ms-auto me-2 pointer"
              onClick={() => {
                setTypeAnItemPopup(false);
                window.localStorage.removeItem("asc_TypeAnItemPopup");
              }}
            >
              x
            </h6>
          </div>
        </div>

        <section
          className="asc_Search_List_Invoice pt-3 ps-0 p-3"
          id="ascSelectBox"
        >
          {productPartList
            .filter(
              (item) =>
                item.productpartname
                  ?.toLowerCase()
                  .includes(productSearchName.toLowerCase()) ||
                item.productPartCode
                  ?.toLowerCase()
                  .includes(productSearchName.toLowerCase()),
            )
            .map((item, index) => {
              return (
                <div key={index} className="">
                  <div class="form-check underTexts_invoice ms-3">
                    <input
                      class="form-check-input pointer"
                      type="checkbox"
                      // value="Not invoiced"
                      id="ascInvoice"
                      // when want to checked only one checkBox
                      // checked={productPartid === item?.productPartid}
                      checked={invoiceList.find(
                        (invoice) =>
                          invoice?.asc_ProductPartid === item.productPartid,
                      )}
                      onClick={() => {
                        let index2 = invoiceList.findIndex(
                          (invoice) =>
                            invoice?.asc_ProductPartid === item.productPartid,
                        );

                        if (index2 !== -1) {
                          let data = [...invoiceList];
                          data.splice(index2, 1);
                          setInvoiceList(data);
                          return;
                        }

                        setProductPartid(item.productPartid);

                        // start item pushing...
                        let invoiceListArray = [...invoiceList];
                        invoiceListArray.push({
                          asc_Name: item.productpartname,
                          asc_productPartCode: item.productPartCode,
                          asc_UnitPrice: item.salePriceexcvat,
                          asc_Total: item.salePriceexcvat * 1,
                          asc_ProductPartid: item.productPartid,
                          asc_Qty: 1,
                          asc_Disc: 0,
                          asc_Vat: 0,
                        });
                        setInvoiceList(invoiceListArray);

                        // setTypeanItem("");
                      }}
                    />
                    <label class="form-check-label w-75" for="flexCheckDefault">
                      <div className="d-flex">
                        <p className="mb-0 w-50">{item.productPartCode}</p>
                        <p className="mb-0 w-50">{item.productpartname}</p>
                      </div>
                    </label>
                  </div>
                </div>
              );
            })}
          {productPartList.length === 0 && (
            <span className="noDataDisplay">
              {/* No data to display! */}
              {t("No data to display!")}
              {/* {FetchTranslationList?.data?.data[94]?.translation} */}
            </span>
          )}
        </section>

        <section>
          <div
            className="p-5"
            style={{
              transform: addTextField ? "scale(1)" : "scale(0)",
              transitionDuration: "300ms",
              position: "absolute",
              top: "5rem",
              left: "11rem",
              background: "#F1F1F1",
              borderRadius: "20px",
              boxShadow: " 0px 5px 10px 0px rgba(0, 0, 0, 0.5)",
            }}
          >
            <div>
              <h6
                className="xCiecle ms-auto me-2 pointer"
                onClick={() => {
                  setAddTextField(false);
                }}
              >
                x
              </h6>
            </div>

            <div className="asc-input-container" id="ascInput">
              <label className="asc-label-top ClientNameText">New Field</label>
              <input
                type="text"
                className="asc_NormalInput ps-4"
                placeholder="Add New Text Field"
                value={newTextField}
                onChange={(e) => {
                  setNewTextField(e.target.value);
                }}
              />
            </div>

            <button
              className="makeInvoBtn mt-5"
              onClick={() => {
                // start item pushing...
                let invoiceListArray = [...invoiceList];
                invoiceListArray.push({
                  asc_Name: newTextField,
                });
                setInvoiceList(invoiceListArray);

                setNewTextField("");
              }}
            >
              {/* Add Field */}
              {t("Add Text Field")}
            </button>
          </div>
        </section>
      </div>
    </section>
  );
};

export const InvoiceNotification = (invoiceResponse) => {
  toast.dismiss();
  toast(<InvoiceNotificationMessage invoiceResponse={invoiceResponse} />, {
    icon: () => <img src={LogoSmall} width={35} />,
    className: "app-notification",
    data: {
      sound: new Audio(floatingSound),
    },
  });
};

const InvoiceNotificationMessage = ({ invoiceResponse }) => {
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Invoice-List-Add-Update").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);
  if (invoiceResponse && invoiceResponse?.status == true) {
    if (invoiceResponse.data && invoiceResponse.data?.isQuickBookError) {
      return (
        <div>
          <label>
            {/* Error while synching to QuickBooks: */}
            {t("Error while synching to QuickBooks")}
          </label>
          <br />
          <label style={{ color: "red" }}>
            {" "}
            {invoiceResponse.data.quickBookErrorDescription}
          </label>
        </div>
      );
    } else {
      return (
        <div>
          {/* Invoice Added Successfully */}
          {t("Invoice Added Successfully")}
        </div>
      );
    }
  } else {
    return (
      <div>
        {/* Failed to add Invoice, Please Try Again */}
        {t("Invoice Added Successfully")}
      </div>
    );
  }
};

export default CreditNote;
